import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Club } from '../model/Club';
import { AcademyAdministratorOperation } from '../model/administrator/AcademyAdministratorOperation';
import { AcademyAdministratorType } from '../model/administrator/AcademyAdministratorType';
import { AdministratorEntity } from '../model/administrator/AdministratorEntity';
import { AdministrationService } from './administration.service';

@Injectable({
  providedIn: 'root',
})
export class ClubService {
  constructor(private readonly administrationService: AdministrationService) {}

  getAllClubs() {
    try {
      let entity: AdministratorEntity = {
        operation: AcademyAdministratorOperation.SELECT,
        payload: null,
        type: AcademyAdministratorType.CLUBES,
      };
      return this.administrationService
        .sendRequest(entity)
        .pipe(catchError(this.handleError.bind(this)))
    } catch (error) {
      console.log('Ocurrió un error consultando los clubes: ', error);
      throw error;
    }
  }

  updateClub(club: Club) {
    let entity: AdministratorEntity = {
      operation: AcademyAdministratorOperation.UPDATE,
      payload: club,
      type: AcademyAdministratorType.CLUBES,
    };
    return this.administrationService.sendRequest(entity);
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 422) {
      return throwError(
        () =>
          new Error(
            'No se puede procesar la consulta de la información del club'
          )
      );
    } else {
      // Return an observable with a user-facing error message.
      return throwError(
        () => new Error('Error desconocido consultando la información del club')
      );
    }
  }
}
